import { render, staticRenderFns } from "./OrderCount.vue?vue&type=template&id=34e1e646"
import script from "./OrderCount.vue?vue&type=script&lang=js"
export * from "./OrderCount.vue?vue&type=script&lang=js"
import style0 from "./OrderCount.vue?vue&type=style&index=0&id=34e1e646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports